import Component from "vue-class-component";
import Vue from "vue";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { PrimoboxExerciceDto } from "../../../dto/GenApi.iNotPaie.Dto/PrimoboxExerciceDto";
import dateHelper from "../../../Helper/dateHelper";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";
import { ModalAlerteOptions } from "../../modalComponents/modalAlerte/modalAlerte";
import { EventBus } from "../../Controls/EventBus";
import EventConstants from "../../Controls/EventConstants";
import { PrimoboxEtatTraitement } from "../../../dto/GenApi.iNotPaie.Dto/PrimoboxEtatTraitement";
import ModalDetailsEnvoiBulletinComponent from "./modalDetailsEnvoiBulletin/modalDetailsEnvoiBulletin";
import * as $ from "jquery";
import { primoboxHelper } from "../primoboxHelper";

@Component({
	components: {
		ModalDetailsEnvoiBulletinComponent: require("./modalDetailsEnvoiBulletin/modalDetailsEnvoiBulletin.vue.html")
	},
	beforeRouteEnter(to, from, next) {
		next(v => {
			const vm = (v as EnvoiBulletinsComponent);
			vm.init();
		});
	}
})
export default class EnvoiBulletinsComponent extends Vue {
	public dataReady = false;

	public primoboxExercices: PrimoboxExerciceDto[] = [];

	public modalDetailsEnvoiBulletinComponent?: ModalDetailsEnvoiBulletinComponent = undefined;

	private init(): void {
    	this.updateAndGetPrimoboxExercices();
	}

	public formatMoisAnnee(mois: number, annee: number): string {
    	return dateHelper.geLibelleDateMoisAnnee(mois, annee);
	}

	//Met à jour le traitement dans la liste avec les nouvelles données
	public updateTraitement(idExercice: number, newData: PrimoboxExerciceDto): void {
		const index = this.primoboxExercices.findIndex((exercice) => exercice.IdExercice == idExercice);
		if (index !== -1) {
			this.primoboxExercices[index] = newData;
			this.$forceUpdate();
		}
	}

	// Permet d'ouvrir la modal de distribution
	public openModalDistribuer(exercice: PrimoboxExerciceDto): void {
		this.modalDetailsEnvoiBulletinComponent = this.$refs.modalDetailsEnvoiBulletinComponent as ModalDetailsEnvoiBulletinComponent;

		this.modalDetailsEnvoiBulletinComponent.Init(exercice);
		$("#modalDetailsEnvoiBulletinComponent").modal("show");
	}

	// Permet de synchroniser les salariés de l'exercice avec primobox
	public synchroniser(idContrats: number[],onfulfilled?: () => void): void {
		this.dataReady = false;

		NotificationServiceInstance.SendInformation("Début de la synchronisation des salariés.");
		ServicesFactoryInstance.PrimoboxService.synchronizePrimoboxSalaries(idContrats,
			(data) => {
				NotificationServiceInstance.SendSuccess("La synchronisation des salariés avec Primobox est terminée.");

				if (onfulfilled) {
					onfulfilled();
				} else {
					this.dataReady = true;
				}
			},
			(error) => {
				this.dataReady = true;
			}
		);
	}

	public synchroniserAndDistribuer(exercice: PrimoboxExerciceDto): void {
		this.dataReady = false;
		this.synchroniser([], () => {
			NotificationServiceInstance.SendInformation("Début de la création du traitement de distribution.");
			ServicesFactoryInstance.PrimoboxService.distributeBulletins(exercice.IdExercice,
				(data) => {
					this.updateTraitement(exercice.IdExercice, data);
					NotificationServiceInstance.SendSuccess("La distribution des bulletins est en cours de traitement.");
					this.dataReady = true;
				},
				(error) => {
					this.dataReady = true;
				}
			);
		});
	}

	public synchroniserAndRedistribuer(exercice: PrimoboxExerciceDto, idContrats: number[]): void {
		this.dataReady = false;
		this.synchroniser(idContrats, () => {
			NotificationServiceInstance.SendInformation("Début de la création du traitement de redistribution.");
			ServicesFactoryInstance.PrimoboxService.redistributeBulletins(exercice.IdExercice, idContrats,
				(data) => {
					exercice.PossedeRedistribution = true;
					this.updateTraitement(exercice.IdExercice, exercice);
					NotificationServiceInstance.SendSuccess("La redistribution des bulletins est en cours de traitement.");
					this.dataReady = true;
				},
				(error) => {
					this.dataReady = true;
				}
			);
		});
	}
    
	// Permet de valider l'envoi des bulletins de l'exercice
	public validerDistribution(exercice: PrimoboxExerciceDto): void {
    	if (!exercice || !exercice.IdTraitementExercice) {
    		// L'id de traitement doit être renseigné.
    		NotificationServiceInstance.SendFailed("L'exercice à valider est vide ou n'a pas d'identifiant.");

    		return;
    	}

    	const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
    		message: "En cliquant sur valider, vous ne pourrez plus modifier la distribution des bulletins.<br><br>Souhaitez-vous continuer ?",
    		title: "CONFIRMATION DE LA DISTRIBUTION",
    		callBackYes: () :void => {
    			this.dataReady = false;
    			ServicesFactoryInstance.PrimoboxService.validerDistribution(exercice.IdTraitementExercice ?? -1,
					(data) => {

						this.updateTraitement(exercice.IdExercice, data);
    					NotificationServiceInstance.SendSuccess("La validation du traitement a été effectuée.");
    					this.dataReady = true;

    					this.refresh();
    				},
    				(error) => {
    					this.dataReady = true;
    				}
    			);
			},
			callBackNo: () :void => {
			}
    	});
    	EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
	}

	// Permet de valider une redistribution
	public validerRedistribution(idTraitement?: number): void {
		this.dataReady = false;
		ServicesFactoryInstance.PrimoboxService.validerDistribution(idTraitement ?? -1,
			(data) => {

				NotificationServiceInstance.SendSuccess("La validation de la redistribution a été effectuée.");
				this.dataReady = true;
				this.refresh();
			},
			(error) => {
				this.dataReady = true;
			});
	}

	// Permet d'affichage un message lorsqu'on clique sur le lien anomalie
	public messageAnomalie(): void {
		primoboxHelper.messageAnomalie();
	}

	// Bouton rafraichir
	public refresh(): void {
		this.updateAndGetPrimoboxExercices();
	}

	// Conversion des états en libellé
	public convertEtatToString(etat: PrimoboxEtatTraitement): string {
		return primoboxHelper.convertPrimoboxEtatToString(etat);
	}

	// Permet de savoir le style de texte à afficher pour les états
	public canShowSimpleEtat(etat: PrimoboxEtatTraitement): boolean {
		return primoboxHelper.canShowSimpleEtat(etat);
	}

	public canShowAnomalieEtat(etat: PrimoboxEtatTraitement): boolean {
		return primoboxHelper.canShowAnomalieEtat(etat);
	}

	public canShowValiderEtat(etat: PrimoboxEtatTraitement): boolean {
		return primoboxHelper.canShowValiderEtat(etat);
	}

	public canValidate(exercice: PrimoboxExerciceDto): boolean {
    	return exercice && exercice.EstExerciceCloture && exercice.EtatEnum === PrimoboxEtatTraitement.ValidationEnAttente;
	}

	public canDistribute(exercice: PrimoboxExerciceDto): boolean {
    	return exercice && exercice.EstExerciceCloture && exercice.EtatEnum === PrimoboxEtatTraitement.NonDistribue;
	}

	// Permet de savoir si le bouton de distribution doit être affiché. S'il est caché c'est le bouton "Voir le détail"" qui s'affiche
	public canShowButtonDistribuer(etat: PrimoboxEtatTraitement): boolean {
		return etat !== PrimoboxEtatTraitement.Termine;
	}

	// Mise à jour des états des traitements (call API primobox) puis récupération de la liste des exercices
	private updateAndGetPrimoboxExercices(): void {
    	this.dataReady = false;
    	ServicesFactoryInstance.PrimoboxService.updatePrimoboxExercices(undefined,
    		(status) => {
    			ServicesFactoryInstance.PrimoboxService.getPrimoboxExercices(
    				(data) => {
    					this.primoboxExercices = data;
    					this.dataReady = true;
    				},
    				(error) => {
    					this.primoboxExercices = [];
    					this.dataReady = true;
    				}
    			);
    		},
    		(error) => {
    			this.primoboxExercices = [];
    			this.dataReady = true;
    		}
    	);
	}
    
}



// WEBPACK FOOTER //
// ./src/components/Primobox/envoiBulletins/envoiBulletins.ts